(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content-library"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new WeakMap();

    class LibraryDrawer {
      constructor(root) {
        this.root = root;
        this.dialog = root.querySelector('.content-library__drawer');
        this.fallback = root.querySelector('.content-library__mobile-navigation');
        this.trigger = this.fallback.querySelector('summary');
        if (typeof this.dialog.showModal !== 'function') return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.media = matchMedia('(max-width: 989px)');
        this.dialog.querySelector('.content-library__drawer-body').append(this.fallback.querySelector('.content-library__mobile-navigation-content'));
        this.dialog.querySelectorAll('[data-library-group]').forEach((group) => {
          const heading = group.querySelector('.content-library__navigation-heading');
          const details = document.createElement('details');
          const summary = document.createElement('summary');
          const label = document.createElement('span');
          label.textContent = heading.textContent;
          const count = document.createElement('span');
          count.className = 'content-library__drawer-count';
          summary.append(label, count);
          details.append(summary, group.querySelector('ul'));
          heading.replaceWith(details);
        });
        this.trigger.setAttribute('aria-haspopup', 'dialog');
        this.trigger.setAttribute('role', 'button');
        this.trigger.setAttribute('aria-controls', this.dialog.id);
        this.trigger.setAttribute('aria-expanded', 'false');
        this.trigger.addEventListener('click', (event) => {
          event.preventDefault();
          if (!this.media.matches || this.dialog.open) return;
          this.refresh();
          this.previousOverflow = [document.documentElement.style.overflow, document.body.style.overflow];
          document.documentElement.style.overflow = 'hidden';
          document.body.style.overflow = 'hidden';
          this.dialog.showModal();
          this.trigger.setAttribute('aria-expanded', 'true');
        }, options);
        this.dialog.querySelector('.content-library__drawer-close').addEventListener('click', () => this.close(), options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target.closest('a[href]')) this.close();
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
        }, options);
        this.dialog.addEventListener('close', () => { if (!this.dialog.open) this.restore(); }, options);
        this.media.addEventListener('change', () => { if (!this.media.matches) this.close(); }, options);
        window.addEventListener('pageshow', (event) => { if (event.persisted) this.close(); }, options);
      }

      refresh() {
        if (!this.events) return;
        this.dialog.querySelectorAll('[data-library-group]').forEach((group) => {
          group.querySelector('.content-library__drawer-count').textContent = `(${group.querySelectorAll('[data-library-article-id]').length})`;
          if (group.querySelector('[aria-current="page"]')) group.querySelector('details').open = true;
        });
        this.dialog.querySelector('.content-library__drawer-empty').hidden = Boolean(this.dialog.querySelector('[data-library-article-id]'));
      }

      restore() {
        if (!this.previousOverflow) return;
        [document.documentElement.style.overflow, document.body.style.overflow] = this.previousOverflow;
        this.previousOverflow = null;
        this.trigger.setAttribute('aria-expanded', 'false');
        if (this.root.isConnected && this.media.matches) this.trigger.focus({ preventScroll: true });
      }

      close() {
        if (this.dialog.open) this.dialog.close();
        this.restore();
      }

      destroy() {
        this.close();
        this.events?.abort();
      }
    }

    class LibraryIndex {
      constructor(root) {
        this.root = root;
        this.status = root.querySelector('[data-library-status]');
        this.retry = root.querySelector('[data-library-retry]');
        this.page = Number(root.dataset.libraryPage);
        this.pages = Math.max(1, Number(root.dataset.libraryPages));
        this.drawer = new LibraryDrawer(root);
        this.retry.addEventListener('click', () => this.load());
        this.load();
      }

      async load() {
        if (this.loading) return;
        this.loading = true;
        this.controller = new AbortController();
        this.retry.hidden = true;
        const chunks = new Map([[this.page, this.root]]);
        try {
          if (!Number.isInteger(this.pages) || this.pages > 500 || this.page < 1 || this.page > this.pages) {
            throw new Error('Invalid content index pagination');
          }
          for (let page = 1; page <= this.pages; page += 1) {
            if (chunks.has(page)) continue;
            this.status.textContent = `Loading all content (${chunks.size} of ${this.pages} index pages)…`;
            const url = new URL(window.location.href);
            url.hash = '';
            url.searchParams.delete('sections');
            url.searchParams.set('section_id', this.root.dataset.sectionId);
            url.searchParams.set(this.root.dataset.libraryPageParam || 'page', String(page));
            const timeout = setTimeout(() => this.controller.abort(), 15000);
            let html;
            try {
              const response = await fetch(url, { signal: this.controller.signal, credentials: 'same-origin' });
              if (!response.ok) throw new Error('Content index request failed');
              html = await response.text();
            } finally {
              clearTimeout(timeout);
            }
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const chunk = [...doc.querySelectorAll('[data-content-library]')].find(
              (element) => element.dataset.sectionId === this.root.dataset.sectionId
            );
            if (!chunk || chunk.dataset.libraryBlog !== this.root.dataset.libraryBlog ||
                Number(chunk.dataset.libraryPage) !== page || Number(chunk.dataset.libraryPages) !== this.pages) {
              throw new Error('Content index changed or could not render');
            }
            chunks.set(page, chunk);
          }
          if (!this.root.isConnected) return;
          const groups = new Map();
          let latest;
          // Read one navigation copy per page, in source order. Never inject fetched scripts.
          for (let page = 1; page <= this.pages; page += 1) {
            const chunk = chunks.get(page);
            latest ||= chunk.querySelector('[data-library-overview] .content-library__latest');
            chunk.querySelector('.content-library__navigation').querySelectorAll('[data-library-group]').forEach((group) => {
              const key = group.dataset.libraryGroup;
              if (!groups.has(key)) groups.set(key, new Map());
              group.querySelectorAll('[data-library-article-id]').forEach((link) => {
                const id = link.dataset.libraryArticleId;
                if (!groups.get(key).has(id)) groups.get(key).set(id, link.closest('li').cloneNode(true));
              });
            });
          }
          const focused = document.activeElement;
          const focusedId = focused?.dataset.libraryArticleId;
          const focusedNav = focused?.closest('.content-library__navigation');
          this.root.querySelectorAll('[data-library-group]').forEach((group) => {
            const items = [...(groups.get(group.dataset.libraryGroup)?.values() || [])];
            group.querySelector('ul').replaceChildren(...items.map((item) => {
              const clone = item.cloneNode(true);
              const link = clone.querySelector('a');
              link.removeAttribute('aria-current');
              if (link.dataset.libraryArticleId === this.root.dataset.libraryActiveId) link.setAttribute('aria-current', 'page');
              return clone;
            }));
            group.hidden = items.length === 0;
          });
          if (focusedId && focusedNav) {
            [...focusedNav.querySelectorAll('[data-library-article-id]')].find((link) => link.dataset.libraryArticleId === focusedId)?.focus({preventScroll:true});
          }
          const overview = this.root.querySelector('[data-library-overview]');
          if (overview && latest) {
            const existing = overview.querySelector('.content-library__latest');
            if (existing?.dataset.libraryLatestId !== latest.dataset.libraryLatestId) {
              const hadFocus = overview.contains(document.activeElement);
              overview.replaceChildren(latest.cloneNode(true));
              if (hadFocus) overview.querySelector('.button')?.focus({preventScroll:true});
            }
            overview.querySelector('[data-library-latest-label]').textContent = 'Latest content';
          } else if (overview && this.pages > 1) {
            overview.querySelector('h2').textContent = 'No library content yet';
            overview.querySelector('p').textContent = 'New content will appear here when it is published.';
          }
          const ids = new Set([...groups.values()].flatMap((items) => [...items.keys()]));
          this.status.textContent = ids.size ? `${ids.size} ${ids.size === 1 ? 'item' : 'items'} in the library.` : '';
          this.root.querySelectorAll('[data-library-pagination]').forEach((navigation) => { navigation.hidden = true; });
          this.root.dataset.libraryState = 'complete';
          this.drawer.refresh();
        } catch {
          if (this.root.isConnected) {
            this.status.textContent = 'The full index could not load. Use the index page links below or retry.';
            this.retry.hidden = false;
            this.root.dataset.libraryState = 'error';
            this.drawer.refresh();
          }
        } finally {
          this.loading = false;
        }
      }
    }

    function initialize(scope) {
      scope.querySelectorAll('[data-content-library]').forEach((root) => {
        if (!instances.has(root)) instances.set(root, new LibraryIndex(root));
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), {once:true});
    else initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-content-library]').forEach((root) => {
        const instance = instances.get(root);
        instance?.controller?.abort();
        instance?.drawer.destroy();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
